var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8.25H6.75C7.575 8.25 8.25 7.575 8.25 6.75V3.75C8.25 2.925 7.575 2.25 6.75 2.25H3.75C2.925 2.25 2.25 2.925 2.25 3.75V6.75C2.25 7.575 2.925 8.25 3.75 8.25Z",
    fill: "#002D62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15.75H6.75C7.575 15.75 8.25 15.075 8.25 14.25V11.25C8.25 10.425 7.575 9.75 6.75 9.75H3.75C2.925 9.75 2.25 10.425 2.25 11.25V14.25C2.25 15.075 2.925 15.75 3.75 15.75Z",
    fill: "#002D62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 3.75V6.75C9.75 7.575 10.425 8.25 11.25 8.25H14.25C15.075 8.25 15.75 7.575 15.75 6.75V3.75C15.75 2.925 15.075 2.25 14.25 2.25H11.25C10.425 2.25 9.75 2.925 9.75 3.75Z",
    fill: "#002D62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15.75H14.25C15.075 15.75 15.75 15.075 15.75 14.25V11.25C15.75 10.425 15.075 9.75 14.25 9.75H11.25C10.425 9.75 9.75 10.425 9.75 11.25V14.25C9.75 15.075 10.425 15.75 11.25 15.75Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridView);
export default __webpack_public_path__ + "static/media/grid-view.09ea9745eda1469cf604395727eb31ff.svg";
export { ForwardRef as ReactComponent };